// src/App.tsx

import * as React from "react";

import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import PublicHome from "./app/public-home/PublicHome";

import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

/* -------------------------------------------------------------------------- */
/* App                                                                        */
/* -------------------------------------------------------------------------- */

export default function App():
React.JSX.Element {
  return (
    <React.Suspense
      fallback={
        null
      }
    >
      <Routes>
        <Route
          index
          element={
            <PublicHome />
          }
        />

        <Route
          path="/privacy"
          element={
            <Privacy />
          }
        />

        <Route
          path="/terms"
          element={
            <Terms />
          }
        />

        <Route
          path="*"
          element={
            <Navigate
              to="/"
              replace
            />
          }
        />
      </Routes>
    </React.Suspense>
  );
}